import { defineComponent } from 'vue';
import { QCard, QCardSection } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

const CARD_LIST_CLICK_CODE_BEHIND = {
    handlerSuffix: '_Click',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your click handler here\n\t}`;
    },
};

export default defineComponent({
    name: 'card-list-dsgn',
    mixins: [BaseComponentMixin],
    components: { QCard, QCardSection },
    computed: {
        containerStyle() {
            return {
                overflow: 'auto',
                ...utils.getSize(this.controlData?.SizeOptions, this.parentType, this.$parent),
                ...utils.getStyleHints(this.controlData?.StyleHints, this),
            };
        },
        labelField() {
            return this.controlData?.ListCardTemplate?.Label || 'Label';
        },
    },
    methods: {
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, CARD_LIST_CLICK_CODE_BEHIND);
        },
    },
    render() {
        if (!this.controlData)
            return null;

        const cards = [0, 1].map((i) => (
            <QCard key={i} flat bordered class="q-ma-xs" style={{ background: i === 0 ? '#f5f5f5' : '#fff' }}>
                <QCardSection class="q-py-sm">
                    {i === 0 ? this.labelField : 'Card item'}
                </QCardSection>
            </QCard>
        ));

        return (
            <div
                class={{ 'c-CardList': true, 'designer-container': true, selected: this.selected$ }}
                style={this.containerStyle}
                onClick={(e) => this.handleClick(e)}
                onDblclick={(e) => this.handleDesignerDblClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />
                {cards}
            </div>
        );
    },
});
